const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')

const shape = labelify({
  name: yup.string().default(''),
  value: yup.string().default(''),
  menuTemplate: yup.object().shape({
    columns: yup.array().of(yup.string()).default([]),
    instructions: yup.array().of(yup.string()).default([]),
    filename: yup.string(),
    isMarkdown: yup.boolean().default(false),
  }),
  activity: yup.mixed(),
})

const genericTypeSchemaPartial = yup.object().shape(shape)
const genericTypeSchema = genericTypeSchemaPartial.shape(requiredFields(['name'])(shape))

module.exports = { genericTypeSchema, genericTypeSchemaPartial }
